// extracted by mini-css-extract-plugin
export default {"profileInfo":"ProfileInfo_profileInfo__lwIt3","imgBox":"ProfileInfo_imgBox__pD52j","img_box":"ProfileInfo_img_box__jx9vO"};